import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Menu, X, Star } from 'lucide-react';
import { functions } from '../firebaseConfig';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async (e) => {
    e.preventDefault();
    const auth = getAuth();
    try {
      const logoutFn = httpsCallable(functions, 'logout_user');
      await logoutFn();
    } catch (error) {
      console.error('Erro ao revogar sessão:', error);
    }
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Erro ao sair:', error);
    }
  };

  const menuItems = [
    { href: '/meus-mapas', label: 'Meus Mapas' },
    { href: '/profile', label: 'Perfil' }
  ];

  const linkClass = (path) =>
    `transition-colors ${
      location.pathname === path
        ? 'text-purple-600 font-medium'
        : 'text-gray-600 hover:text-purple-600'
    }`;

  return (
    <nav className="bg-white border-b border-purple-100 shadow-sm w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/meus-mapas" className="flex items-center gap-2 text-xl font-bold">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center">
              <Star className="w-3.5 h-3.5 text-white" fill="white" />
            </div>
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              MapaAstral<span className="text-pink-500">.ai</span>
            </span>
          </Link>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center gap-6">
            {menuItems.map((item) => (
              <Link key={item.href} to={item.href} className={linkClass(item.href)}>
                {item.label}
              </Link>
            ))}
            <button
              onClick={handleLogout}
              className="text-gray-600 hover:text-purple-600 transition-colors"
            >
              Sair
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 text-gray-600 hover:text-purple-600"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-purple-50">
            <div className="flex flex-col gap-1 pt-2">
              {menuItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`px-3 py-2 rounded-lg ${linkClass(item.href)}`}
                >
                  {item.label}
                </Link>
              ))}
              <button
                onClick={(e) => { setMobileMenuOpen(false); handleLogout(e); }}
                className="px-3 py-2 rounded-lg text-left text-gray-600 hover:text-purple-600 transition-colors"
              >
                Sair
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;